export default "__VITE_ASSET__ClekPBnG__"